import FatherSonImage from './fatherSonImage1.png'
import FatherSonImage2 from './fatherSonImage2.png'
import ApproachFrame1 from './approachFrame1.jpg'
import ApproachFrame2 from './approachFrame2.jpg'
import ApproachFrame3 from './approachFrame3.jpg'
import HeroImage from './HeroImage.png'

export const AiEdgeImages = {
    FatherSonImage,
    FatherSonImage2,
    ApproachFrame1,
    ApproachFrame2,
    ApproachFrame3,
    HeroImage
}
